import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EntryLayout } from '../../components/EntryLayout';
import { FilterChip } from '../../components/FilterChip';
import { Button } from '../../components/ui/Button';
import { useLocale } from '../../contexts/LocaleContext';
import { useSession } from '../../contexts/SessionContext';
const activityIds = ['strength', 'running', 'cycling', 'swimming', 'triathlon', 'crossfit', 'yoga', 'pilates', 'beachTennis', 'jiujitsu', 'muayThai', 'boxing', 'mobility', 'mindfulness', 'nutrition'];

/** MOB/Onboarding/Activities — decides which sport metrics appear on the profile. */
export function OnboardingActivities() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const {
    activities,
    toggleActivity
  } = useSession();
  return <EntryLayout title={t('onb.act.title')} body={t('onb.act.body')} step={3} totalSteps={5} footer={<Button variant="gold" size="lg" fullWidth disabled={activities.length === 0} onClick={() => navigate('/onboarding/preferencias')} data-id="element-3381" data-mp="2oxop56jnnhp4">
          {t('onb.continue')}
        </Button>} data-id="element-3380" data-mp="2ttdi2r1660cg">
      <ul className="flex flex-wrap gap-2" data-id="element-3382" data-mp="wih6iu7bw1g3">
        {activityIds.map(id => <li key={id} data-id="element-3383" data-mp="11fzg8mt66kp5">
            <FilterChip label={t(`onb.act.${id}`)} active={activities.includes(id)} onClick={() => toggleActivity(id)} data-id="element-3384" data-mp="11haoaytneem2" />
          </li>)}
      </ul>
    </EntryLayout>;
}